module.exports = __webpack_public_path__ + "ab02082a02a348a88eadb2cc4cef9da0.png";


//////////////////
// WEBPACK FOOTER
// ./images/dummy.png
// module id = 209
// module chunks = 0